<template>
    <div></div>
</template>

<script>
export default {
    name: "not-logged"
};
</script>
